<app-page-wrapper [title]="'helpGuide' | i18n">
  <!-- The cards are clickable <div>s; appKeyboardActivatable makes each a Tab stop (role=button)
       that Enter/Space activates, like a click. -->
  <div
    class="tw-flex tw-w-full tw-flex-row sm:tw-flex-col tw-flex-wrap tw-gap-4 tw-py-6 tw-content-start"
  >
    <div
      class="tw-rounded-xl tw-bg-color-surface-card tw-p-4 tw-flex tw-w-[calc(50%-8px)] sm:tw-w-full tw-h-[140px] tw-flex-col tw-items-start tw-cursor-pointer tw-shadow-elevation-card dark:tw-bg-transparent"
      (click)="openHelpBox()"
      appKeyboardActivatable
      (appKeyboardActivatableActivate)="openHelpBox()"
    >
      <div
        class="tw-flex tw-flex-none tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-lg tw-bg-dt-surface-elevated tw-p-0"
      >
        <icon [size]="8" name="smile" class="tw-text-dt-text-tertiary"></icon>
      </div>
      <div class="tw-mt-2 tw-flex tw-w-full tw-items-center tw-justify-between">
        <div
          class="tw-text-base tw-font-medium tw-text-dt-text-headings tw-whitespace-normal tw-break-words tw-capitalize"
        >
          {{ "support" | i18n }}
          <div
            class="tw-mt-0 tw-text-sm tw-font-medium tw-text-dt-text-secondary tw-whitespace-normal tw-break-words tw-normal-case"
          >
            {{ "supportInquiries" | i18n }}
          </div>
        </div>
        <icon [name]="'right-arrow'" [size]="5"></icon>
      </div>
    </div>

    <div
      class="tw-rounded-xl tw-bg-color-surface-card tw-p-4 tw-flex tw-w-[calc(50%-8px)] sm:tw-w-full tw-h-[140px] tw-flex-col tw-items-start tw-cursor-pointer tw-shadow-elevation-card dark:tw-bg-transparent"
      (click)="openFaq()"
      appKeyboardActivatable
      (appKeyboardActivatableActivate)="openFaq()"
    >
      <div
        class="tw-flex tw-flex-none tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-lg tw-bg-dt-surface-elevated tw-p-0"
      >
        <icon [size]="8" name="help" class="tw-text-dt-text-tertiary"></icon>
      </div>
      <div class="tw-mt-2 tw-flex tw-w-full tw-items-center tw-justify-between">
        <div
          class="tw-text-base tw-font-medium tw-text-dt-text-headings tw-whitespace-normal tw-break-words tw-capitalize"
        >
          {{ "officialQ&A" | i18n }}
          <div
            class="tw-mt-0 tw-text-sm tw-font-medium tw-text-dt-text-secondary tw-whitespace-normal tw-break-words tw-normal-case"
          >
            {{ "officialQuestions" | i18n }}
          </div>
        </div>
        <icon [size]="5" name="link"></icon>
      </div>
    </div>

    <div
      class="tw-rounded-xl tw-bg-color-surface-card tw-p-4 tw-flex tw-w-[calc(50%-8px)] sm:tw-w-full tw-h-[140px] tw-flex-col tw-items-start tw-cursor-pointer tw-shadow-elevation-card dark:tw-bg-transparent"
      (click)="goToGuideDetail()"
      appKeyboardActivatable
      (appKeyboardActivatableActivate)="goToGuideDetail()"
    >
      <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
        <icon [size]="8" name="route" class="tw-text-dt-text-tertiary"></icon>
        <span
          class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-highlight-200 tw-text-dt-text-contrast tw-normal-case tw-leading-none tw-font-bold tw-text-[13px] tw-w-[103px] tw-h-[24px]"
        >
          {{ "inProgress" | i18n }}
        </span>
      </div>
      <div class="tw-mt-2 tw-flex tw-w-full tw-items-center tw-justify-between">
        <div
          class="tw-text-base tw-font-medium tw-text-dt-text-headings tw-whitespace-normal tw-break-words tw-capitalize"
        >
          <span class="tw-flex tw-items-center tw-gap-2">
            {{ "guide" | i18n }}
          </span>
          <div
            class="tw-mt-0 tw-text-sm tw-font-medium tw-text-dt-text-secondary tw-whitespace-normal tw-break-words tw-normal-case"
          >
            {{ "guideDescription" | i18n }}
          </div>
        </div>
        <icon [name]="'right-arrow'" [size]="5"></icon>
      </div>
    </div>
  </div>
</app-page-wrapper>
